import { faArrowLeft, faArrowRight, faPlus, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PMS_CATEGORY_CARD_ICON } from "constants/constants";
import { useLanguage } from "context/LanguageContext";

const PmsCategoryCardDetail = ({ focusExit, handleFocusExit, setFocusedCardId, title = "", totalForms = 0, focusedCardRef, forms = [] }) => {
    const { language } = useLanguage();
    return (
        <div className="fixed inset-0 z-40 flex items-center justify-center">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-[6px] transition-all duration-500 animate-fadeIn" onClick={focusExit ? undefined : handleFocusExit} />
            <div className="flex flex-col w-full max-w-[700px] min-h-[400px] max-h-[80vh] bg-white/30 backdrop-blur-xl shadow-2xl border border-white/50 rounded-3xl z-50 relative p-0 overflow-hidden" style={{ margin: '2vh auto', boxSizing: 'border-box' }}>
                {/* Sticky Glassy Header */}
                <div className="sticky top-0 z-10 flex items-center justify-between w-full px-6 py-3 bg-white/40 backdrop-blur-lg border-b border-white/30" style={{ backdropFilter: 'blur(16px)' }}>
                    <button
                        className="px-5 py-2 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 text-white font-bold shadow-md hover:shadow-lg transition-all duration-300 flex items-center gap-2 group z-50 text-base"
                        onClick={() => {
                            setFocusedCardId(null);
                        }}
                        disabled={focusExit}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} className="text-base group-hover:translate-x-1 transition-transform" />
                        {language ? 'Back to Categories' : 'العودة للفئات'}
                    </button>
                    <div className="flex items-center gap-3 bg-white/60 px-4 py-2 rounded-2xl shadow text-gray-800 text-sm font-bold">
                        <FontAwesomeIcon icon={faUser} className="text-lg" />
                        <span>{title}</span>
                        <span className="ml-2 bg-orange-500 text-white rounded-full px-2 py-0.5 text-xs">{totalForms}</span>
                    </div>
                </div>
                {/* Cards Area with Custom Scrollbar */}
                <div className="flex-1 overflow-y-auto w-full pt-4 px-6 pb-6 scrollbar-thin scrollbar-thumb-blue-200 scrollbar-track-transparent" style={{ scrollbarWidth: 'thin' }}>
                    <div
                        key={title}
                        ref={focusedCardRef}
                        className={`focused-card-true relative rounded-2xl border border-white/30 bg-gradient-to-br from-white/60 via-blue-100/60 to-white/40 shadow-xl flex flex-col min-w-0 w-full animate-fadeInUp mb-4`}
                        style={{ padding: '1.25rem', alignSelf: 'center', zIndex: 50, pointerEvents: focusExit ? 'none' : 'auto', opacity: focusExit ? 0.7 : 1, backdropFilter: 'blur(10px)' }}
                    >
                        {/* Category Header */}
                        <div className="flex items-center gap-3 mb-4">
                            <div className="relative">
                                <div className="w-12 h-12 bg-gradient-to-br from-blue-400/40 to-purple-400/40 backdrop-blur-md rounded-xl flex items-center justify-center shadow border border-white/30">
                                    <FontAwesomeIcon icon={PMS_CATEGORY_CARD_ICON(title)} className="text-2xl text-blue-700 drop-shadow-lg" />
                                </div>
                                <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center border border-white shadow animate-pulse">
                                    <span className="text-white text-xs font-bold">{totalForms}</span>
                                </div>
                            </div>
                            <div className="flex-1">
                                <h3 className="text-lg font-bold tracking-wide text-blue-900 mb-1 drop-shadow-lg bg-gradient-to-r from-blue-900 to-purple-700 bg-clip-text text-transparent">
                                    {title}
                                </h3>
                            </div>
                        </div>
                        {/* Forms Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {forms.map(form => (
                                <div
                                    key={form.id}
                                    className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                                    style={{ animationDelay: `${1 * 80}ms` }}
                                    onClick={form.handleFormClick}
                                >
                                    {/* Form Header */}
                                    <div className="flex items-center gap-2 mb-4">
                                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                                            <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                                        </div>
                                        <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                                            {form.ar_name}
                                        </h4>
                                    </div>
                                    {/* Action Button */}
                                    <div className="pt-2 mt-auto">
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                form.handleFormClick();
                                            }}
                                            className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                                        >
                                            <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                                            <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                                            <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PmsCategoryCardDetail;